export default "__VITE_ASSET__a689da28__"